import { useInfiniteQuery, useQuery, useQueryClient } from 'react-query';
import { DevopsAPI } from 'api';
import { TInfiniteQuery, TQuery } from 'api/api.types';

export const useSearchDevopsProjects = ({ args = {}, ...config }: TQuery = {}) => {
  const queryFn = async () => {
    const { data } = await DevopsAPI.searchDevopsProjects(args);
    return data;
  };

  return useQuery(['devops-list', args], queryFn, {
    staleTime: 1000 * 60 * 5,
    keepPreviousData: true,
    ...config
  });
};
